/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useMemo, useState } from 'react';

import PropTypes from 'prop-types';
import { Button, Col, DatePicker, Form, Input, Radio, Row, Select, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { debounce } from 'lodash';
import dayjs from 'dayjs';

import { ReactComponent as Picker } from '../../../assets/date-picker-icon.svg';
import { ReactComponent as Attached } from '../img/attached.svg';
import { ReactComponent as DelImage } from '../img/del-cross-icon.svg';
import { ReactComponent as Pluse } from '../../../assets/pluse-black-icon.svg';
import { ReactComponent as Delete } from '../../../assets/delete-black-icon.svg';


import CustomRadioButton from '../../../components/CustomRadioButton/CustomRadioButton';
import CustomSelect from '../../../components/CustomSelect/CustomSelect';
// import CustomPhoneInput from '../../../components/CustomPhoneInput/CustomPhoneInput';
import CustomInputNumber from '../../../components/CustomInputNumber/CustomInputNumber';
import { CustomTextarea } from '../../../components/CustomTextfield/CustomTextfield';
import CustomCheckbox from '../../../components/CustomCheckbox/CustomCheckbox';
import { deleteFormInputElement, getFormInputElementById, getOnboardingById, uploadOnboardingDocument } from '../../../data/store/onboarding/onboardingActions';
import { useDispatch, useSelector } from 'react-redux';
import OnboardingFileViewer from '../OnboardingFileViewer/OnboardingFileViewer';
import api from '../../../utils/API';
import { decimalSeparator as decFunc } from '../../../helpers/decimalSeparator';
import { API_URLS } from '../../../constants/api_urls';
import { getValueObj } from '../OnboardingCategory';
import { formatter, parser } from '../../../helpers/formatterInput';

/** Ant Design DatePicker + Form ожидают dayjs или undefined; иначе падает date.isValid в useInvalidate */
const normalizePickerFormValue = (val) => {
  if (val == null || val === '') {
    return undefined;
  }
  if (typeof val === 'object' && typeof val.isValid === 'function') {
    return val.isValid() ? val : undefined;
  }
  const parsed = dayjs(val);
  return parsed.isValid() ? parsed : undefined;
};

const OnboardingItemFabrica = ({
  form,
  formItem,
  onboardingId,
  composite = null,
  multiName = null,
  /** Табличный композит: значения уходят на бэк только по кнопке сохранения строки, не по blur/change */
  deferRemoteSubmit = false,
  /** Не-table композит: вместо itemSubmit вызывается после blur/изменения (валидация строки — в родителе) */
  onDeferredBlur,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { onboardingById, uploadDocs} = useSelector(state => state.onboardingReducer);

  const decimalSeparator = decFunc();

  useEffect(() => {
    if(onboardingById && formItem && formItem?.form_input_element?.type === 'FILE') {
      const file = onboardingById?.form_input_element_submissions?.find(i => i.form_input_element_id === formItem?.form_input_element?.id);
      if(file) {
        dispatch(getFormInputElementById(file?.id));
      }
    }
  }, [onboardingById]);

  /*
  const obj = {
    form_input_element_id: item,
    form_submission_id: onboardingById?.id,
    [type?.valueType?.toLowerCase()]: i,
  };
  */
  const createFormInputElement = async(data) => {
    return await api.post(API_URLS.CREATE_FORM_INPUT_ELEMENT_V3, data);
  };
  const editInputElement = async(data) => {
    const { id, ...rest } = data;
    return await api.put(API_URLS.EDIT_FORM_INPUT_ELEMENT_V3(id), rest);
  };
  const deleteInputElement = async(id) => {
    return await api.delete(API_URLS.EDIT_FORM_INPUT_ELEMENT_V3(id));
  };

  const getFieldName = () => {
    if (multiName !== null) {
      return [multiName, formItem?.form_input_element?.id];
    }
    if (composite) {
      return [composite, formItem?.form_input_element?.id];
    }
    return formItem?.form_input_element?.id;
  };

  const name = getFieldName();

  /** Полный namePath в корневой форме (для validateFields одного затронутого поля) */
  const fullValidationPath = useMemo(() => {
    if (composite != null && multiName !== null) {
      const n = name;
      return Array.isArray(n) ? [composite, ...n] : [composite, multiName, n];
    }
    return name;
  }, [composite, multiName, name]);

  const invokeDeferredBlur = useCallback(
    async (blurFieldPath) => {
      if (onDeferredBlur) {
        await onDeferredBlur(blurFieldPath ?? fullValidationPath);
      }
    },
    [fullValidationPath, onDeferredBlur],
  );

  const itemSubmit = async(value, checked = true, multiValue = false, formDataId = null, update = false) => {
      if (deferRemoteSubmit) {
        return;
      }
      const storedItem = onboardingById?.form_input_element_submissions?.find(i => i.form_input_element_id === formItem.form_input_element.id);
      const typeItem = getValueObj(formItem.form_input_element, value);

      let statusElement = storedItem && !multiValue 
        ? (checked 
          ? 'edit' 
          : 'delete') 
        : !value
          ? 'delete'
          : multiValue === 'several' 
            ? formDataId ? 'edit' : 'new'
            : multiValue && !checked
              ? 'delete'
              : 'new';
      console.log('🚀 ~ itemSubmit ~ statusElement:', statusElement);

      const obj = {
        ...typeItem,
        form_input_element_id: formItem.form_input_element.id,
        form_submission_id: onboardingId,
      };

      if(statusElement === 'new') {
        try {
          await createFormInputElement(obj);
          dispatch(getOnboardingById(onboardingId));
        } catch (error) {
          const message = error?.response?.data?.form_input_element_validation_errors
          ?.find(i => i.form_input_element_id === formItem.form_input_element.id)?.message;
          console.log('response error',message ?? 'Error validate field');
          form.setFields([
            {
              name: name,
              errors: [message],
            },
          ]);
        }
      } else if(statusElement === 'edit') {
        obj.id = storedItem?.id;
        try {
          await editInputElement(obj);
          update && dispatch(getOnboardingById(onboardingId));
        } catch (error) {
          const message = error?.response?.data?.form_input_element_validation_errors
          ?.find(i => i.form_input_element_id === formItem.form_input_element.id)?.message;
          console.log('response error',message ?? 'Error validate field');
          form.setFields([
            {
              name: name,
              errors: [message],
            },
          ]);
        }
      } else if(statusElement === 'delete') {
        const key = Object.keys(typeItem)[0];
        const hasDelete = onboardingById?.form_input_element_submissions
          ?.filter(i => i.form_input_element_id === formItem.form_input_element.id)
          ?.find(j => j[key] === typeItem[key]);
        if(hasDelete || formDataId) {
          try {
            await deleteInputElement(formDataId ?? hasDelete?.id);
            update && dispatch(getOnboardingById(onboardingId));
          } catch (error) {
            const message = error?.response?.data?.form_input_element_validation_errors
            ?.find(i => i.form_input_element_id === formItem.form_input_element.id)?.message;
            console.log('response error',message ?? 'Error validate field');
            form.setFields([
              {
                name: name,
                errors: [message],
              },
            ]);
          }
        }
      }
    };

  
  const Date = () => {
    const handleChange = (data) => {
      if (!deferRemoteSubmit) {
        itemSubmit(data);
      }
    };
    const handleBlur = async () => {
      if (deferRemoteSubmit && onDeferredBlur) {
        await invokeDeferredBlur();
      }
    };
    return (
      <Form.Item
        label={formItem?.form_input_element?.description}
        className={
          formItem?.form_input_element?.min_number_of_submissions === 1
            ? 'custom-required'
            : ''
        }
        name={name}
        rules={[
          {
            required:
              formItem?.form_input_element?.min_number_of_submissions === 1,
            message: t('ENTER_DATA'),
          },
        ]}
        required={false}
        normalize={normalizePickerFormValue}
        getValueProps={(v) => ({ value: normalizePickerFormValue(v) })}
      >
        <DatePicker
          className="custom-datepicker"
          suffixIcon={<Picker />}
          placeholder={formItem?.form_input_element?.hint}
          format="YYYY-MM-DD"
          onChange={(data) => handleChange(data)}
          onBlur={handleBlur}
        />
      </Form.Item>
    );
  };

  const DateTime = () => {
    const handleChange = (data) => {
      if (!deferRemoteSubmit) {
        itemSubmit(data);
      }
    };
    const handleBlur = async () => {
      if (deferRemoteSubmit && onDeferredBlur) {
        await invokeDeferredBlur();
      }
    };
    return (
      <Form.Item
        label={formItem?.form_input_element?.description}
        className={
          formItem?.form_input_element?.min_number_of_submissions === 1
            ? 'custom-required'
            : ''
        }
        name={name}
        rules={[
          {
            required:
              formItem?.form_input_element?.min_number_of_submissions === 1,
            message: t('ENTER_DATA'),
          },
        ]}
        required={false}
        normalize={normalizePickerFormValue}
        getValueProps={(v) => ({ value: normalizePickerFormValue(v) })}
      >
        <DatePicker
          className="custom-datepicker"
          showTime={{ format: 'HH:mm', secondStep: 60 }}
          suffixIcon={<Picker />}
          placeholder={formItem?.form_input_element?.hint}
          format="YYYY-MM-DD"
          onChange={(data) => handleChange(data)}
          onBlur={handleBlur}
        />
      </Form.Item>
    );
  };

  const ListFixed = () => {
    const multiValue = !Object.hasOwn(formItem.form_input_element, 'max_number_of_submissions') ||
      formItem?.form_input_element?.max_number_of_submissions === null;
    
    const options = formItem?.options?.display_options?.map((i, index) => {
      return {
        label: i,
        value: formItem?.options?.options?.[index],
      };
    });

    const handleChange = (e, value) => {
      if (deferRemoteSubmit && onDeferredBlur) {
        if (multiValue) {
          void invokeDeferredBlur([
            ...(composite != null ? [composite] : []),
            ...(Array.isArray(name) ? name : [name]),
            value,
          ]);
        } else {
          void invokeDeferredBlur();
        }
        return;
      }
      if(multiValue) {
        itemSubmit(value, e.target.checked, multiValue);
      } else {
        itemSubmit(e.target.value);
      }
    };

    return (
      multiValue 
      ? (
        <div className="onboarding-checkbox-group">
          <p>{formItem?.form_input_element?.description}{formItem?.form_input_element?.min_number_of_submissions === 1 ? ' *' : ''}</p>
          {options?.map((i) => (
            <Form.Item
              key={i?.value}
              name={[name, i.value]}
              valuePropName="checked"
              className={
                'filter-check-item' +
                  formItem?.form_input_element?.min_number_of_submissions ===
                1
                  ? 'custom-required'
                  : ''
              }
              required={false}
            >
              <CustomCheckbox onChange={(e) => handleChange(e, i.value)}>
                {i?.label}
              </CustomCheckbox>
            </Form.Item>
          ))}
        </div>
        )
      : (

      <Form.Item
        label={formItem?.form_input_element?.description}
        name={name}
        required={false}
        className={formItem?.form_input_element?.min_number_of_submissions === 1
            ? 'custom-required radio-acc-type'
            : 'radio-acc-type'}
        rules={[
          {
            required:
              formItem?.form_input_element?.min_number_of_submissions === 1,
            message: t('ENTER_DATA'),
          },
        ]}
      >
        <Radio.Group value={null} className="onboarding-radiogroup">
          <Space direction="vertical" align="start">
            {options?.map((i) => (
              <CustomRadioButton
                key={i?.value}
                className={'client-signup'}
                value={i?.value}
                onChange={handleChange}
              >
                {i?.label}
              </CustomRadioButton>
            ))}
          </Space>
        </Radio.Group>
      </Form.Item>
      )
    );
  };

  const Text = () => {
    const debouncedLog = useMemo(
      () =>
        debounce(async(value) => {
          try {
            await form.validateFields([name]);
            // itemSubmit(value, value.length > 0, false, null, false);
          } catch (error) {
            console.log('🚀 ~ Text ~ valid error:', error);
          }
        }, 1500),
      []
    );

    const handleChange = (e) => {
        const { value } = e.target;
        debouncedLog(value);
      };

    const handleBlur = async(e) => {
      const { value } = e.target;
      if (deferRemoteSubmit && onDeferredBlur) {
        await invokeDeferredBlur();
        return;
      }
      try {
        await form.validateFields([name]);
        itemSubmit(value, value.length > 0);
      } catch (error) {
        console.log('🚀 ~ Text ~ valid error:', error);
      }
      // dispatch(getOnboardingById(onboardingId));
    };
    return (
      <Form.Item
        label={formItem?.form_input_element?.description}
        name={name}
        className={
          formItem?.form_input_element?.min_number_of_submissions === 1
            ? 'custom-required'
            : ''
        }
        rules={[
          {
            required:
              formItem?.form_input_element?.min_number_of_submissions === 1 && !formItem?.form_input_element?.readonly,
            message: t('ENTER_DATA'),
          },
          {
            min: formItem?.form_input_element?.min_text_length,
            message: t('MIN_LENGTH_VALUE') +': ' + formItem?.form_input_element?.min_text_length,
          },
          {
            max: formItem?.form_input_element?.max_text_length,
            message: t('MAX_LENGTH_VALUE') +': ' + formItem?.form_input_element?.max_text_length,
          },
        ]}
        required={false}
      >{Object.hasOwn(formItem?.form_input_element, 'min_number_of_submissions') &&
        formItem?.form_input_element?.min_number_of_submissions !== null &&
        (
          <Input
            placeholder={formItem?.form_input_element?.hint}
            className="custom-input full-width"
            maxLength={formItem?.form_input_element?.max_text_length}
            minLength={formItem?.form_input_element?.min_text_length}
            readOnly={formItem?.form_input_element?.readonly}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        )
      }
      </Form.Item>
    );
  };

  const Typography = () => {
    return (
      <Form.Item
        label={formItem?.form_input_element?.description}
      >
      </Form.Item>
    );
  };

  const ListDynamic = () => {
    const multiValue = !Object.hasOwn(formItem.form_input_element, 'max_number_of_submissions') ||
      formItem?.form_input_element?.max_number_of_submissions === null;
    const options = useMemo(() => {
      return formItem?.options?.display_options?.map((i, index) => {
        return {
          label: i,
          value: formItem?.options?.options?.[index],
        };
      }) || [];
    }, [formItem?.options?.display_options, formItem?.options?.options]);

    const handleChange = (value) => {
      if (deferRemoteSubmit && onDeferredBlur) {
        void invokeDeferredBlur();
        return;
      }
      itemSubmit(value, true, multiValue);
    };
    const handleDeselect = (value) => {
      if (deferRemoteSubmit && onDeferredBlur) {
        void invokeDeferredBlur();
        return;
      }
      itemSubmit(value, false);
    };
    
    return (
      <Form.Item
        label={formItem?.form_input_element?.description}
        name={name}
        className={
          formItem?.form_input_element?.min_number_of_submissions === 1
            ? 'custom-required'
            : ''
        }
        rules={[
          {
            required:
              formItem?.form_input_element?.min_number_of_submissions === 1,
            message: t('ENTER_DATA'),
          },
        ]}
        required={false}
      >
        <CustomSelect
          mode={multiValue ? 'multiple' : 'default'}
          width={'100%'}
          placeholder={formItem?.form_input_element?.hint}
          className="custom-select"
          showSearch
          filterOption={(inputValue, option) => {
            return inputValue?.length > 1
              ? option?.children?.props?.children
                  ?.toUpperCase()
                  ?.indexOf(inputValue?.toUpperCase()) !== -1
              : true;
          }}
          notFoundContent={<></>}
          onSelect={handleChange}
          onDeselect={handleDeselect}
        >
          {options?.map((item, idx) => {
            return (
              <Select.Option key={`${formItem?.form_input_element?.id}-${item.value}-${idx}`} value={item.value}>
                {item.label}
              </Select.Option>
            );
          })}
        </CustomSelect>
      </Form.Item>
    );
  };

  // const PhoneNumber = () => {
  //   return (
  //     <Form.Item
  //       label={formItem?.form_input_element?.description}
  //       name={name}
  //       className={
  //         formItem?.form_input_element?.min_number_of_submissions === 1
  //           ? 'custom-required'
  //           : ''
  //       }
  //       rules={[
  //         {
  //           required:
  //             formItem?.form_input_element?.min_number_of_submissions === 1,
  //           message: t('ENTER_PHONE_NUMBER'),
  //         },
  //       ]}
  //       required={false}
  //     >
  //       <CustomPhoneInput
  //         popupClassName="onboarding-custom-inputnumber-dropdown"
  //         nameCode={[name, 'country_code']}
  //         width="100%"
  //       />
  //     </Form.Item>
  //   );
  // };
  const Email = () => {
    const multiValue = formItem?.form_input_element?.max_number_of_submissions === null ||
      formItem?.form_input_element?.max_number_of_submissions !== 1 ||
      !Object.hasOwn(formItem?.form_input_element, 'max_number_of_submissions');

    const handleBlur = async(e, fieldIndex) => {
      const { value } = e.target;
      if (deferRemoteSubmit && onDeferredBlur) {
        let blurPath = [...(Array.isArray(name) ? name : [name]), fieldIndex, 'value_text'];
        if (composite != null && multiName !== null) {
          blurPath = [composite, ...blurPath];
        }
        await invokeDeferredBlur(blurPath);
        return;
      }
      const formData = form.getFieldValue(name)?.[fieldIndex];
      if(formData?.id  &&
        onboardingById?.form_input_element_submissions?.find(i => i.id === formData?.id)?.value_text === value) return;
      try {
        await form.validateFields([[name, fieldIndex, 'value_text']]);
        itemSubmit(value, value.length > 0, 'several', formData?.id);
      } catch (error) {
        console.log('🚀 ~ Text ~ valid error:', error);
      }
    };

    const handleRemove = (fieldIndex, callback) => {
      const formDataId = form.getFieldValue(name)?.[fieldIndex]?.id;
      if (formDataId) {
        if (deferRemoteSubmit && onDeferredBlur) {
          dispatch(deleteFormInputElement(formDataId));
          callback(fieldIndex);
          void invokeDeferredBlur();
          return;
        }
        itemSubmit(false, false, true, formDataId);
      } else {
        callback(fieldIndex);
      }
    };

    return (
      !multiValue
      ? (
        <Form.Item
          label={formItem?.form_input_element?.description}
          name={name}
          className={
            formItem?.form_input_element?.min_number_of_submissions === 1
              ? 'custom-required'
              : ''
          }
          rules={[
            {
              required:
                formItem?.form_input_element?.min_number_of_submissions === 1 && !formItem?.form_input_element?.readonly,
              message: t('ENTER_EMAIL_ADDRESS'),
            },
            {
              type: 'email',
              message: t('ENTER_EMAIL_ADDRESS'),
            },
          ]}
          required={false}
        >
          <Input
            placeholder={formItem?.form_input_element?.hint}
            className="custom-input full-width"
            maxLength={formItem?.form_input_element?.max_text_length}
            minLength={formItem?.form_input_element?.min_text_length}
            onBlur={handleBlur}
            onPressEnter={handleBlur}
          />
        </Form.Item>
      )
      : (
        <div className="onboarding-multi-input">
          <p>{formItem?.form_input_element?.description}{formItem?.form_input_element?.min_number_of_submissions === 1 ? ' *' : ''}</p>
          <Form.List name={name}>
            {(fields, { add, remove }) =>{
              console.log('🚀 ~ OnboardingItemFabrica ~ Render Email-LIST:');
              return (
              <>
                {fields.map(({ key, name: fieldIndex }) => (
                  <Row key={key}>
                    <Col span={21}>
                      <Form.Item
                        key={key}
                        name={[fieldIndex, 'value_text']}
                        className={
                          formItem?.form_input_element?.min_number_of_submissions === 1
                            ? 'custom-required'
                            : ''
                        }
                        rules={[
                          {
                            required:
                              formItem?.form_input_element?.min_number_of_submissions === 1 && !formItem?.form_input_element?.readonly,
                            message: t('ENTER_EMAIL_ADDRESS'),
                          },
                          {
                            type: 'email',
                            message: t('ENTER_EMAIL_ADDRESS'),
                          },
                        ]}
                        required={false}
                      >
                        <Input
                          placeholder={formItem?.form_input_element?.hint}
                          className="custom-input full-width"
                          maxLength={formItem?.form_input_element?.max_text_length}
                          minLength={formItem?.form_input_element?.min_text_length}
                          onBlur={(e) => handleBlur(e, fieldIndex)}
                          onPressEnter={(e) => handleBlur(e, fieldIndex)}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={3}  className="onboarding-delete-btn-wrapper" style={{alignItems: 'center', paddingBottom: '0'}}>
                      <Delete
                        className='onboarding-delete-btn'
                        onClick={() => handleRemove(fieldIndex, remove)} />
                    </Col>
                  </Row>
                ))}
                <div>
                  <Button
                    type="text"
                    icon={<Pluse />}
                    iconPosition="end"
                    className="profile-data-addbutton"
                    onClick={() => add()}
                  >
                    {t('ADD')}
                  </Button>
                </div>
              </>
            );}}
          </Form.List>

        </div>
      )
    );
  };

  const Url = () => {
    const debouncedLog = useMemo(
      () =>
        debounce(async(value) => {
          try {
            await form.validateFields([name]);
            // itemSubmit(value, value.length > 0, false, null, false);
          } catch (error) {
            console.log('🚀 ~ Text ~ valid error:', error);
          }
        }, 1500),
      []
    );

    const handleChange = (e) => {
      const { value } = e.target;
      debouncedLog(value);
    };

    const handleBlur = async(e) => {
      const { value } = e.target;
      if (deferRemoteSubmit && onDeferredBlur) {
        await invokeDeferredBlur();
        return;
      }
      try {
        await form.validateFields([name]);
        itemSubmit(value, value.length > 0);
      } catch (error) {
        console.log('🚀 ~ Text ~ valid error:', error);
      }
    };

    return (
      <Form.Item
        label={formItem?.form_input_element?.description}
        name={name}
        className={
          formItem?.form_input_element?.min_number_of_submissions === 1
            ? 'custom-required'
            : ''
        }
        rules={[
          {
            required:
              formItem?.form_input_element?.min_number_of_submissions === 1 && !formItem?.form_input_element?.readonly,
            message: t('ENTER_VALID_URL'),
          },
          {
            type: 'url',
            message: t('ENTER_VALID_URL'),
          },
        ]}
        required={false}
      >
        <Input
          placeholder={formItem?.form_input_element?.hint}
          className="custom-input full-width"
          maxLength={formItem?.form_input_element?.max_text_length}
          minLength={formItem?.form_input_element?.min_text_length}
          onChange={handleChange}
          onPressEnter={handleChange}
          onBlur={handleBlur}
        />
      </Form.Item>
    );
  };

  const Number = () => {
    const debouncedLog = useMemo(
      () =>
        debounce(async(value) => {
          try {
            await form.validateFields([name]);
            // itemSubmit(value, value.length > 0, false, null, false);
          } catch (error) {
            console.log('🚀 ~ Text ~ valid error:', error);
          }
        }, 1500),
      []
    );

    const handleChange = (value) => {
      debouncedLog(value);
    };

    const handleBlur = async(e) => {
      const { value } = e.target;
      console.log('🚀 ~ handleBlur ~ value:', value);
      if (deferRemoteSubmit && onDeferredBlur) {
        await invokeDeferredBlur();
        return;
      }
      try {
        await form.validateFields([name]);
        itemSubmit(+value, value.length > 0);
      } catch (error) {
        console.log('🚀 ~ Text ~ valid error:', error);
      }
    };

    return (
      <Form.Item
        label={formItem?.form_input_element?.description}
        name={name}
        className={
          formItem?.form_input_element?.min_number_of_submissions === 1
            ? 'custom-required'
            : ''
        }
        rules={[
          {
            required:
              formItem?.form_input_element?.min_number_of_submissions === 1 && !formItem?.form_input_element?.readonly,
            message: t('ENTER_DATA'),
          },
        ]}
        required={false}
      >
        <CustomInputNumber
          width={'100%'}
          placeholder={formItem?.form_input_element?.hint}
          min={formItem?.form_input_element?.min_number_value}
          readOnly={formItem?.form_input_element?.readonly}
          controls={false}
          decimalSeparator={decimalSeparator}
          formatter={formatter}
          parser={parser}
          onChange={handleChange}
          onPressEnter={handleChange}
          onBlur={handleBlur}
        />
      </Form.Item>
    );
  };

  const TextMultiline = () => {
    const rowsMin = Math.ceil(formItem?.form_input_element?.max_text_length / 135);
    const rowsMax = Math.ceil(formItem?.form_input_element?.max_text_length / 54);

    const debouncedLog = useMemo(
      () =>
        debounce(async(value) => {
          try {
            await form.validateFields([name]);
            // itemSubmit(value, value.length > 0);
          } catch (error) {
            console.log('🚀 ~ Text ~ valid error:', error);
          }
        }, 1500),
      []
    );

    const handleChange = (e) => {
      const { value } = e.target;
      debouncedLog(value);
    };

    const handleBlur = async(e) => {
      const { value } = e.target;
      if (deferRemoteSubmit && onDeferredBlur) {
        await invokeDeferredBlur();
        return;
      }
      try {
        await form.validateFields([name]);
        itemSubmit(value, value.length > 0);
      } catch (error) {
        console.log('🚀 ~ Text ~ valid error:', error);
      }
    };

    return (
      <Form.Item
        label={formItem?.form_input_element?.description}
        name={name}
        className={
          formItem?.form_input_element?.min_number_of_submissions === 1
            ? 'custom-required'
            : ''
        }
        rules={[
          {
            required:
              formItem?.form_input_element?.min_number_of_submissions === 1,
            message: t('ENTER_DATA'),
          },
        ]}
        required={false}
      >
        <CustomTextarea
          width={'100%'}
          autoSize={{ minRows: rowsMin, maxRows: rowsMax }}
          rows={Math.ceil(rowsMin + rowsMax) / 2}
          placeholder={formItem?.form_input_element?.hint}
          minLength={formItem?.form_input_element?.min_text_length}
          maxLength={formItem?.form_input_element?.max_text_length}
          showCount={true}
          className='onboarding-textarea'
          onChange={handleChange}
          onPressEnter={handleChange}
          onBlur={handleBlur}
        />
      </Form.Item>
    );
  };

  const Confirm = () => {
    const handleChange = (e) => {
      const { checked } = e.target;
      console.log('🚀 ~ handleChange ~ checked:', checked);
      if (deferRemoteSubmit && onDeferredBlur) {
        void invokeDeferredBlur();
        return;
      }
      if(checked) {
        itemSubmit(checked, checked);

      } else {
        const storedItemID = onboardingById?.form_input_element_submissions
        ?.find(i => i.form_input_element_id === formItem.form_input_element.id)?.id;
        console.log('🚀 ~ handleChange ~ storedItemID:', storedItemID);
        itemSubmit(checked, checked, false, storedItemID);
      }
    };
    return (
      <Form.Item
        name={name}
        normalize={(value) => value ?? false}
        valuePropName="checked"
        className={
          'filter-check-item' +
            formItem?.form_input_element?.min_number_of_submissions ===
          1
            ? 'custom-required'
            : ''
        }
        required={false}
      >
        <CustomCheckbox onChange={handleChange}>
          {formItem?.form_input_element?.description}
        </CustomCheckbox>
      </Form.Item>
    );
  };

  const File = ({ item, onboardingId }) => {
    const dispatch = useDispatch();
    const [error, setError] = useState(null);
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);
    const [isLoadingPreview, setIsLoadingPreview] = useState(false);

    const stored = useMemo(() => {
      return onboardingById?.form_input_element_submissions?.find(i => i.form_input_element_id === item?.id);
    }, [onboardingById?.form_input_element_submissions, item?.id]);
    
    const docData = useMemo(() => {
      if (stored?.id && uploadDocs?.[stored.id]?.value_binary_file?.data) {
        return uploadDocs[stored.id].value_binary_file.data;
      }
      return null;
    }, [uploadDocs, stored?.id]);
    
    const docMimeType = useMemo(() => {
      if (stored?.id && uploadDocs?.[stored.id]?.value_binary_file?.mime_type) {
        return uploadDocs[stored.id].value_binary_file.mime_type;
      }
      return stored?.value_binary_file?.mime_type;
    }, [uploadDocs, stored?.id, stored?.value_binary_file?.mime_type]);
    
    const docFileName = useMemo(() => {
      if (stored?.id && uploadDocs?.[stored.id]?.value_binary_file?.name) {
        return uploadDocs[stored.id].value_binary_file.name;
      }
      return stored?.value_binary_file?.name;
    }, [uploadDocs, stored?.id, stored?.value_binary_file?.name]);

    const uploadImage = async(event) => {
      if (deferRemoteSubmit) return;
      const file = event.target.files[0];
      console.log('🚀 ~ uploadImage ~ file:', file);
      if (!file) return;
      
      if(file.size > item?.max_size_bytes) {
        const errorMsg = t('FILE_SIZE_ERROR') + ` : max size ${item?.max_size_bytes / 1024}kB`;
        setError(errorMsg);
        const timer = setTimeout(() => {
          setError(null);
        }, 3000);
        return () => clearTimeout(timer);
      }
      if(file.size < item?.min_size_bytes) {
        const errorMsg = t('FILE_SIZE_ERROR') + `: min size ${item?.min_size_bytes / 1024}kB`;
        setError(errorMsg);
        const timer = setTimeout(() => {
          setError(null);
        }, 3000);
        return () => clearTimeout(timer);
      }
      const fileToToObject = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            const base64Data = reader.result.split(',')[1];
            resolve({
              data: base64Data,
              mime_type: file.type,
              name: file.name
            });
          };
          reader.onerror = (error) => reject(error);
        });
      };
      
      try {
        const binaryFile = await fileToToObject(file);
        const data = {
          form_input_element_id: item?.id,
          form_submission_id: onboardingId,
          value_binary_file: binaryFile,
        };
        dispatch(uploadOnboardingDocument(data));
      } catch(err) {
        console.error('Error uploading file:', err);
        setError(t('FILE_UPLOAD_ERROR') || 'Error uploading file');
        setTimeout(() => setError(null), 3000);
      }
    };

    const handleClearUpload = useCallback(() => {
      if (deferRemoteSubmit) return;
      if (stored?.id) {
        dispatch(deleteFormInputElement(stored?.id));
      }
    }, [stored?.id, dispatch, deferRemoteSubmit]);

    const handleDocumentPreview = useCallback(() => {
      setIsPreviewOpen(true);

      if (docData) {
        return;
      }

      if (stored?.id && !isLoadingPreview) {
        setIsLoadingPreview(true);
        dispatch(getFormInputElementById(stored?.id));
      }
    }, [docData, stored?.id, isLoadingPreview, dispatch]);

    useEffect(() => {
      if (docData && isLoadingPreview) {
        setIsLoadingPreview(false);
      }
    }, [docData]);

    return (
      <div className="image-upload-wrapper onboarding-upload">
        <h2 className="onboarding-table-title" style={{width: '100%'}}>
          {item?.description}
          {formItem?.form_input_element?.min_number_of_submissions === 1
            ? ' *'
            : ''
          }
        </h2>
        {(!stored?.value_binary_file) &&
        <Button
          type="text"
          className="onboarding-upload-btn"
          icon={<Pluse />}
          iconPosition={'end'}
        >
          <input
            type="file"
            accept=".jpg, .jpeg, .png, .pdf, .heic"
            className="item-img-upload"
            onChange={(event) => uploadImage(event)}
          />
          {t('ADD_FILE')}
        </Button>}
        {stored?.value_binary_file ? (
          <div className="upload-documents-wrapper">
            <div
              key={stored?.value_binary_file?.name}
              className="name-upload-wrapper upload-documents"
            >
              <Attached />
              <p
                className="name-uploaded"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleDocumentPreview();
                }}
                style={{ cursor: 'pointer' }}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleDocumentPreview();
                  }
                }}
              >
                {stored?.value_binary_file?.name}
              </p>
              <DelImage
                className="clear-uploaded"
                onClick={() => handleClearUpload()}
              />
            </div>
          </div>
        ) : (
          <p className="onboarding-upload-filename">
            {item?.hint}
          </p>
        )}
        {error && (
          <p className="onboarding-upload-error">
            {error}
          </p>
        )}
        <OnboardingFileViewer
          open={isPreviewOpen}
          onClose={() => setIsPreviewOpen(false)}
          fileData={docData}
          mimeType={docMimeType}
          fileName={docFileName}
        />
      </div>
    );
  };

  File.propTypes = {
    item: PropTypes.shape({
      id: PropTypes.string,
      description: PropTypes.string,
      hint: PropTypes.string,
      max_size_bytes: PropTypes.number,
      min_size_bytes: PropTypes.number,
    }),
    onboardingId: PropTypes.string,
  };

  if (formItem?.form_input_element?.type === 'DATE') {
    return <Date />;
  } else if (formItem?.form_input_element?.type === 'DATE_TIME') {
    return <DateTime />;
  } else if (formItem?.form_input_element?.type === 'LIST_FIXED') {
    return <ListFixed />;
  } else if (formItem?.form_input_element?.type === 'TEXT') {
    return <Text />;
  } else if (formItem?.form_input_element?.type === 'NONE') {
    return <Typography />;
  } else if (formItem?.form_input_element?.type === 'LIST_DYNAMIC') {
    return <ListDynamic />;
  } else if (formItem?.form_input_element?.type === 'PHONE_NUMBER') {
    return <Text />;
  } else if (formItem?.form_input_element?.type === 'EMAIL') {
    return <Email />;
  } else if (formItem?.form_input_element?.type === 'NUMBER') {
    return <Number />;
  } else if (formItem?.form_input_element?.type === 'TEXT_MULTILINE') {
    return <TextMultiline />;
  } else if (formItem?.form_input_element?.type === 'CONFIRM') {
    return <Confirm />;
  } else if (formItem?.form_input_element?.type === 'FILE') {
    return (
      <File
        key={formItem?.form_input_element?.id}
        item={formItem?.form_input_element}
        onboardingId={onboardingId}
      />
    );
  } else if (formItem?.form_input_element?.type === 'URL') {
    return <Url />;
  } else {
    return <div>{formItem?.form_input_element?.type}</div>;
  }
};

export default React.memo(OnboardingItemFabrica);

OnboardingItemFabrica.propTypes = {
  form: PropTypes.object,
  formItem: PropTypes.object,
  onboardingId: PropTypes.string,
  composite: PropTypes.string,
  multiName: PropTypes.number,
  onChange: PropTypes.func,
  deferRemoteSubmit: PropTypes.bool,
  onDeferredBlur: PropTypes.func,
};